export class OrderDetails {
    Reference_Number: string;
    Amount: string;
    Currency: string;
    Transaction_Description: string;
    Customer_Name: string;
    Customer_Email: string;
    Customer_Contact: string;
    Customer_IP: string;
    PaymentType: string;
    Promo_Code: string;
    Customization: string;

    constructor(data?: Partial<OrderDetails>) {
        Object.assign(this, data);

    }
}

export enum PaymentId {
    Loyalty = 0,
    Reserved = 1,
    Visa_MasterCard = 2,
    FPX_PERSONAL_ACCOUNT = 3,
    AMEX_CreditCard = 4,
    Alipay_Spot_QR = 5,
    UPOP = 6,
    UPI_QR_Code = 7,
    Internet_Banking = 8,
    FPX_CORPORATE_ACCOUNT = 9,
    MerchanTrade = 10,
    Axiata_Boost = 11,
    Maybank_QR = 12,
    DiGi_VCash = 13,
    WeChat_Pay = 14,
    Alipay_Online = 15,
    AirAsia_BIG = 16,
    Grab_Pay = 17,
    Internet_Banking_MayBank = 18,
    Internet_Banking_CIMB = 19,
    Internet_Banking_RHB = 20,
    Internet_Banking_Public_Bank = 21,
    Internet_Banking_Hong_Leong_Bank = 22,
    Internet_Banking_AmBank = 23,
    Internet_Banking_Bank_Rakyat = 24,
    Internet_Banking_Bank_Muamalat = 25,
    Internet_Banking_BSN = 26,
    Hong_Leong_Bank_Scan_and_Pay = 27,
    Touch_n_Go = 28,
    Diners_Club = 29,
    ShopeePay = 33,
    B_Infinite_Pay = 34,
    WannaPay = 35,
    DuitNow_QR = 37,
    Union_Pay_International = 38

}

export function getPaymentId(selectedPaymentType) {
    let paymentType = 1;
    switch (selectedPaymentType) {
        case 'Reserved':
            paymentType = PaymentId.Reserved;
            break;
        case 'Visa_MasterCard':
            paymentType = PaymentId.Visa_MasterCard;
            break;
        case 'FPX_PERSONAL_ACCOUNT':
            paymentType = PaymentId.FPX_PERSONAL_ACCOUNT;
            break;
        case 'AMEX_CreditCard':
            paymentType = PaymentId.AMEX_CreditCard;
            break;
        case 'Alipay_Spot_QR':
            paymentType = PaymentId.Alipay_Spot_QR;
            break;
        case 'UPOP':
            paymentType = PaymentId.UPOP;
            break;
        case 'UPI_QR_Code':
            paymentType = PaymentId.UPI_QR_Code;
            break;
        case 'Internet_Banking':
            paymentType = PaymentId.Internet_Banking;
            break;
        case 'FPX_CORPORATE_ACCOUNT':
            paymentType = PaymentId.FPX_CORPORATE_ACCOUNT;
            break;
        case 'MerchanTrade':
            paymentType = PaymentId.MerchanTrade;
            break;
        case 'Axiata_Boost':
            paymentType = PaymentId.Axiata_Boost;
            break;
        case 'Maybank_QR':
            paymentType = PaymentId.Maybank_QR;
            break;
        case 'DiGi_VCash':
            paymentType = PaymentId.DiGi_VCash;
            break;
        case 'WeChat_Pay':
            paymentType = PaymentId.WeChat_Pay;
            break;
        case 'Alipay_Online':
            paymentType = PaymentId.Alipay_Online;
            break;
        case 'AirAsia_BIG':
            paymentType = PaymentId.AirAsia_BIG;
            break;
        case 'Grab_Pay':
            paymentType = PaymentId.Grab_Pay;
            break;
        case 'Internet_Banking_MayBank':
            paymentType = PaymentId.Internet_Banking_MayBank;
            break;
        case 'Internet_Banking_CIMB':
            paymentType = PaymentId.Internet_Banking_CIMB;
            break;
        case 'Internet_Banking_RHB':
            paymentType = PaymentId.Internet_Banking_RHB;
            break;
        case 'Internet_Banking_Public_Bank':
            paymentType = PaymentId.Internet_Banking_Public_Bank;
            break;
        case 'Internet_Banking_Hong_Leong_Bank':
            paymentType = PaymentId.Internet_Banking_Hong_Leong_Bank;
            break;
        case 'Internet_Banking_AmBank':
            paymentType = PaymentId.Internet_Banking_AmBank;
            break;
        case 'Internet_Banking_Bank_Rakyat':
            paymentType = PaymentId.Internet_Banking_Bank_Rakyat;
            break;
        case 'Internet_Banking_Bank_Muamalat':
            paymentType = PaymentId.Internet_Banking_Bank_Muamalat;
            break;
        case 'Internet_Banking_BSN':
            paymentType = PaymentId.Internet_Banking_BSN;
            break;
        case 'Hong_Leong_Bank_Scan_and_Pay':
            paymentType = PaymentId.Hong_Leong_Bank_Scan_and_Pay;
            break;
        case 'Touch_n_Go':
            paymentType = PaymentId.Touch_n_Go;
            break;
        case 'Diners_Club':
            paymentType = PaymentId.Diners_Club;
            break;
        case 'Loyalty':
            paymentType = PaymentId.Loyalty;
            break;
        case 'DuitNow':
            paymentType = PaymentId.DuitNow_QR;
            break;
    }
    return paymentType;
}
